import React, { useRef, useState, useEffect, useContext, ReactEventHandler } from 'react'
import { 
    Container,
    HeaderDiv,
    HeaderText,
    CloseDiv,
    CloseImg,
    InputsDiv,
    InputDiv,
    InputLabel,
    Input,
    MediumInput,
    TabsDiv,
    CustomInput,
    SwitchDiv,
    SwitchLabel,
    SwitchInput,
    SwitchBox,
    SwitchSlider,
    ButtonsDiv,
    WarningDiv,
    WarningText,
    CancelButton,
    SaveButtonDiv,
    SaveButtonImage,
    SaveButtonText,
    TabsDotsImg,
    TabsText,
    TabsCloseImg,
    TabDiv,
    InputEdit
 } from './style'
import ModalContext from '../../../contexts/ModalContext'
import cross from '../../../assets/certificates/AddParameter/Modal/cross.svg'
import save from '../../../assets/certificates/AddParameter/Modal/save.svg'
import sixDots from '../../../assets/certificates/AddParameter/Modal/six-dots.svg'
import ParametersContext, { StructureObject } from '../../../contexts/ParametersContext'
import FormatsDropdown from '../FormatsDropdown'
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd'

 const EditParameterModal: React.FC = () => {
    const { setModalActive, setModalSection } = useContext(ModalContext)
    const { structures, setStructures, editStructureIndex } = useContext(ParametersContext)
    const [ warningType, setWarningType ] = useState<string>('')
    const [ redFields, setRedFields ] = useState<string[]>([])
    const [ isFormatDropdownOpen, setIsFormatDropdownOpen ] = useState<boolean>(false)
    const [ name, setName ] = useState(structures[editStructureIndex].name)
    const [ rowsInput, setRowsInput ] = useState('')
    const [ columnsInput, setColumnsInput ] = useState('')
    const [ rows, setRows ] = useState<string[]>(structures[editStructureIndex].tableRows || [])
    const [ columns, setColumns ] = useState<string[]>(structures[editStructureIndex].tableColumns || [])
    const [ format, setFormat ] = useState(structures[editStructureIndex].format)
    const [ file, setFile ] = useState(structures[editStructureIndex].fileImport)
    const [ minMax, setMinMax] = useState<boolean>(structures[editStructureIndex].hasMinMax)
    const [editIndexRow, setEditIndexRow] = useState<number | null>(null)
    const [editIndexColumn, setEditIndexColumn] = useState<number | null>(null)

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const {name, value} = e.target
        setWarningType('')
        setRedFields([])
        if (name === 'rowsInput'){
            if (value.charAt(value.length - 1) === ',') {
                if (rows.includes(rowsInput)){
                    setWarningType('rowsRepeatedNames')
                    setRedFields(['rows'])
                    return
                }
                if (rowsInput === ''){
                    return
                }
                const newRows = [...rows]
                newRows.push(rowsInput)
                setRows(newRows)
                setRowsInput('')
            } else {
                setRowsInput(value)
            }
        //único outro caso é columnsInput
        } else {
            if (value.charAt(value.length - 1) === ',') {
                if (columns.includes(columnsInput)){
                    setWarningType('columnsRepeatedNames')
                    setRedFields(['columns'])
                    return
                }
                if (columnsInput === ''){
                    return
                }
                const newColumns = [...columns]
                newColumns.push(columnsInput)
                setColumns(newColumns)
                setColumnsInput('')
            } else {
                setColumnsInput(value)
            }
        }
    }

    const removeItem = (index: number, type: string) => {
        setWarningType('')
        setRedFields([])
        if (type === 'rowsInput'){
            const newRows = [...rows]
            newRows.splice(index, 1)
            setRows(newRows)
        } else {
            const newColumns = [...columns]
            newColumns.splice(index, 1)
            setColumns(newColumns)
        }
    }

    const handleEdit = () => {
        if (errorCheck()){
            return
        }
        if(rows.length === 0){
            rows.push('')
        }
        let structureHasTable = false
        let newMinTable: string[][] = []
        let newMaxTable: string[][] = []
        if (rows.length !== 0 && columns.length !== 0 && format !== ''){
            structureHasTable = true
            if (minMax){
                newMaxTable = Array.from({ length: rows.length }, () => Array(columns.length).fill(''));
                for (let i = 0; i < structures[editStructureIndex].maxTable.length && i < newMaxTable.length; i++){
                    for (let j = 0; j < structures[editStructureIndex].maxTable[i].length && j < newMaxTable[i].length; j++){
                        newMaxTable[i][j] = structures[editStructureIndex].maxTable[i][j]
                    }
                }
                newMinTable = Array.from({ length: rows.length }, () => Array(columns.length).fill(''));
                for (let i = 0; i < structures[editStructureIndex].minTable.length && i < newMinTable.length; i++){
                    for (let j = 0; j < structures[editStructureIndex].minTable.length && j < newMinTable.length; j++){
                        newMinTable[i][j] = structures[editStructureIndex].minTable[i][j]
                    }
                }
            }
        }
        const newStructure: StructureObject = {
            name: name,
            fileImport: file,
            hasTable: structureHasTable,
            tableRows: rows,
            tableColumns: columns,
            format: format,
            hasMinMax: minMax,
            maxTable: newMaxTable,
            minTable: newMinTable,
        }
        if (structures[editStructureIndex].id){
            newStructure.id = structures[editStructureIndex].id
        }
        const currentStructures = [...structures]
        currentStructures[editStructureIndex] = newStructure
        setStructures(currentStructures)
        setModalActive(false)
    }

    const errorCheck = () => {
        if (name === '') {
            setWarningType('nameless')
            setRedFields(['name'])
            return true
        }
        if (checkExistingStructures(name)) {
            setWarningType('structureRepeatedNames')
            setRedFields(['name'])
            return true
        }
        const rowsFilled = rows.length !== 0
        const columnsFilled = columns.length !== 0
        const formatFilled = format !== ''
        //Se algum dos três campos necessários para a tabela está preenchido, mas não todos
        if ((columnsFilled || formatFilled) && !(columnsFilled && formatFilled)) {
            setWarningType('missingTableFields')
            const newRedFields: string[] = []
            if (!columnsFilled){
                newRedFields.push('columns')
            }
            if (!formatFilled){
                newRedFields.push('format')
            }
            setRedFields(newRedFields)
            return true
        } else if (!(columnsFilled || formatFilled)) {
            if (!file){
                setWarningType('noContent') 
                return true
            }
        }
        return false
    }

    //Essas funções são assim só para também incluirem o setWarningType, pois acho que usar um useEffect pode complicar futuramente
    const handleSetName = (e: React.ChangeEvent<HTMLInputElement>) => {
        setName(e.target.value)
        if (checkExistingStructures(e.target.value)) {
            setWarningType('structureRepeatedNames')
            setRedFields(['name'])
            return
        }
        setWarningType('')
        setRedFields([])
    }

    const checkExistingStructures = (value: string) => {
        const structuresWithoutCurrentStructure = [...structures]
        structuresWithoutCurrentStructure.splice(editStructureIndex, 1)
        const repeatedName = structuresWithoutCurrentStructure.some(item => item.name === value)
        if (repeatedName){
            return true
        }
        return false
    }

    const handleSetFile = () => {
        setWarningType('')
        setRedFields([])
        setFile(!file)
    }

    const handleSetFormat = (value: string) => {
        setWarningType('')
        setRedFields([])
        if (value === 'Customizado'){
            setFormat('')  
        } else {
            setFormat(value)
        }
        setIsFormatDropdownOpen(false)
    }

    const handleSetMinMax = () => {
        setWarningType('')
        setRedFields([])
        setMinMax(!minMax)
    }

    let warningMessage = ''
    switch (warningType) {
        case 'structureRepeatedNames':
            warningMessage = 'Não são permitidos nomes repetidos de estrutura!'
            break
        case 'rowsRepeatedNames':
            warningMessage = 'Não são permitidos nomes repetidos de linha!'
            break
        case 'columnsRepeatedNames':
            warningMessage = 'Não são permitidos nomes repetidos de coluna!'
            break
        case 'nameless':
            warningMessage = 'Está faltando um nome!'
            break
        case 'noContent':
            warningMessage = 'A estrutura precisa ter uma tabela ou um input de arquivo!'
            break
        case 'missingTableFields':
            warningMessage = 'A tabela precisa dos campos "Colunas" e "Formato" preenchidos!'
            break
        default:
            break;
    }

    const onDragEndRows = (result:any) => {
        if (!result.destination) return

        const updatedList = [...rows]
        const [moved] = updatedList.splice(result.source.index, 1)
        updatedList.splice(result.destination.index, 0, moved)
        setRows(updatedList)
    }

    const onDragEndColumns = (result:any) => {
        if (!result.destination) return
        
        const updatedList = [...columns]
        const [moved] = updatedList.splice(result.source.index, 1)
        updatedList.splice(result.destination.index, 0, moved)
        setColumns(updatedList)
    }
    
    const handleChangeRows = (e:React.ChangeEvent<HTMLInputElement>, index:number) => {
        const newItems = [...rows]
        newItems[index] = e.target.value
        setRows(newItems)
    }
    
    const handleChangeColumns = (e:React.ChangeEvent<HTMLInputElement>, index:number) => {
        const newItems = [...columns]
        newItems[index] = e.target.value
        setColumns(newItems)
    }

    const handleKeyDown = (e:React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === 'Enter' || e.key === ','){
            setEditIndexRow(null)
            setEditIndexColumn(null)
        }
    }

    return (
        <Container>
            <HeaderDiv>
                <HeaderText>Editar estrutura</HeaderText>
                <CloseDiv onClick={() => setModalActive(false)}>
                    <CloseImg src={cross} alt='Close tab'/>
                </CloseDiv>
            </HeaderDiv>
            <InputDiv>
                <InputLabel htmlFor='name'>Nome da estrutura</InputLabel>
                <Input 
                    placeholder='Digite aqui'
                    name='name'
                    value={name}
                    onChange={(e) => handleSetName(e)}
                    autoComplete="off"
                    className={redFields.includes('name') ? 'redBorder' : ''}
                />
            </InputDiv>
            <InputsDiv>
                <InputDiv>
                    <InputLabel htmlFor='columnsInput'>Colunas</InputLabel>
                    <MediumInput 
                        placeholder='Digite separando com vírgula para adicionar. Ex.: "Temperatura, M. Resfriamento,"'
                        name='columnsInput'
                        value={columnsInput}
                        onChange={(e) => handleChange(e)}
                        autoComplete="off"
                        className={redFields.includes('columns') ? 'redBorder' : ''}
                    />
                </InputDiv>
                <InputDiv>
                    <InputLabel htmlFor='format'>Formato</InputLabel>
                    {isFormatDropdownOpen ? <FormatsDropdown onChange={(value) => handleSetFormat(value)} /> : null}
                    <CustomInput
                        value={format}
                        onChange={(e) => handleSetFormat(e.target.value)}
                        className={redFields.includes('format') ? 'redBorder' : ''}
                        onFocus={() => setIsFormatDropdownOpen(true)}
                        onBlur={() => setIsFormatDropdownOpen(false)}
                        onClick={()  => setIsFormatDropdownOpen(true)}
                    />
                </InputDiv>
            </InputsDiv>
            <DragDropContext onDragEnd={onDragEndColumns}>
                <Droppable droppableId='columns-droppable' direction='horizontal'>
                {(provided, snapshot) => (
                    <TabsDiv {...provided.droppableProps} ref={provided.innerRef}>
                        {columns.map((item, index) => (
                            <Draggable key={index} draggableId={`${item}-${index}`} index={index}>
                                {(provided) => (
                                    <TabDiv
                                        ref={provided.innerRef}
                                        {...provided.draggableProps}
                                        {...provided.dragHandleProps}
                                    > 
                                        <TabsDotsImg src={sixDots} alt='Dots image'/>
                                        {
                                            editIndexColumn !== index ?
                                                <TabsText onClick={() => setEditIndexColumn(index)}>{item}</TabsText>
                                            : 
                                                <InputEdit 
                                                    value={item}
                                                    onBlur={() => setEditIndexColumn(null)}
                                                    autoFocus 
                                                    onChange={(e) => handleChangeColumns(e,index)}
                                                    onKeyDown={(e) => handleKeyDown(e)}
                                                />
                                        }
                                        <TabsCloseImg 
                                            src={cross}
                                            alt='Close image'
                                            onClick={() => removeItem(index, 'columnsInput')}
                                        />
                                    </TabDiv>
                                )}
                            </Draggable>
                        ))}
                        {provided.placeholder}
                    </TabsDiv>
                )}
                </Droppable>
            </DragDropContext>
            <InputsDiv>
                <InputDiv>
                    <InputLabel htmlFor='rowsInput'>Linhas</InputLabel>
                    <MediumInput 
                        placeholder='Digite separando com vírgula para adicionar. Ex.: "Temperatura, M. Resfriamento,"'
                        name='rowsInput'
                        value={rowsInput}
                        onChange={(e) => handleChange(e)}
                        autoComplete="off"
                        className={redFields.includes('rows') ? 'redBorder' : ''}
                    />
                </InputDiv>
                <SwitchDiv className='onInputsDiv'>
                    <SwitchLabel htmlFor='minMax'>Máximo/Mínimo</SwitchLabel>
                    <SwitchBox>
                        <SwitchInput 
                            type='checkbox'
                            name='minMax'
                            checked={minMax}
                            onChange={() => handleSetMinMax()}
                        />
                        <SwitchSlider className='slider'></SwitchSlider>
                    </SwitchBox>
                </SwitchDiv>
            </InputsDiv>
            <DragDropContext onDragEnd={onDragEndRows}>
                <Droppable droppableId='rows-droppable' direction='horizontal'>
                {(provided, snapshot) => (
                    <TabsDiv {...provided.droppableProps} ref={provided.innerRef}>
                        {rows.map((item, index) => (
                            <Draggable key={index} draggableId={`${item}-${index}`} index={index}>
                                {(provided) => (
                                    <TabDiv
                                        ref={provided.innerRef}
                                        {...provided.draggableProps}
                                        {...provided.dragHandleProps}
                                    > 
                                        <TabsDotsImg src={sixDots} alt='Dots image'/>
                                        {
                                            editIndexRow !== index ?
                                                <TabsText onClick={() => setEditIndexRow(index)}>{item}</TabsText>
                                            : 
                                                <InputEdit 
                                                    value={item}
                                                    onBlur={() => setEditIndexRow(null)}
                                                    autoFocus 
                                                    onChange={(e) => handleChangeRows(e,index)}
                                                    onKeyDown={(e) => handleKeyDown(e)}
                                                />
                                        }
                                        <TabsCloseImg 
                                            src={cross}
                                            alt='Close image'
                                            onClick={() => removeItem(index, 'rowsInput')}
                                        />
                                    </TabDiv>
                                )}
                            </Draggable>
                        ))}
                        {provided.placeholder}
                    </TabsDiv>
                )}
                </Droppable>
            </DragDropContext>
            <SwitchDiv>
                <SwitchLabel htmlFor='file'>Permitir importação de imagem</SwitchLabel>
                <SwitchBox>
                    <SwitchInput 
                        type='checkbox'
                        name='file'
                        checked={file}
                        onChange={() => handleSetFile()}
                    />
                    <SwitchSlider className='slider'></SwitchSlider>
                </SwitchBox>
            </SwitchDiv>
            <ButtonsDiv>
                <WarningDiv>
                    <WarningText>{warningMessage}</WarningText>
                </WarningDiv>
                <CancelButton onClick={() => setModalActive(false)}>Cancelar</CancelButton>
                <SaveButtonDiv 
                    onClick={() => handleEdit()}
                    className={warningType !== '' ? 'disabledButton' : ''}
                >
                    <SaveButtonImage src={save} alt='Right arrow icon'/>
                    <SaveButtonText>Salvar alterações</SaveButtonText>
                </SaveButtonDiv>
            </ButtonsDiv>
        </Container>
    )
}

export default EditParameterModal